import { Action, createReducer, on } from '@ngrx/store';
import * as loadingActions from '../actions/loading.actions';

export const loadingFeatureKey = 'loading';

export interface State {
    current: string[];
    finished: number;
}

export const initialState: State = {
    current: [],
    finished: 0
};

const loadingReducer = createReducer(
    initialState,
    on(loadingActions.addLoading, (state, { actionType }) => {
        return {
            ...state,
            current: [...state.current, actionType].filter(unique)
        };
    }),
    on(loadingActions.stopLoading, (state) => {
        const newFinished = state.finished + 1;
        if (newFinished >= state.current.length) {
            return {
                ...state,
                current: [],
                finished: 0
            };
        }

        return { ...state, finished: newFinished };
    }),
    on(loadingActions.forcesStopLoading, (state) => ({
        ...state,
        current: [],
        finished: 0
    }))
);

function unique(value, index, self) {
    return self.indexOf(value) === index;
}

export function reducer(state: State | undefined, action: Action) {
    return loadingReducer(state, action);
}
